export const KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const KNOWLEDGE_BASE_PDF_MIME_TYPE = 'application/pdf';

export type KnowledgeBaseUploadValidationError = 'campaignRequired' | 'fileType' | 'fileSize';

export interface KnowledgeBaseUploadFileLike {
  name: string;
  type: string;
  size: number;
}

export const hasKnowledgeBaseDuplicateFileName = (
  files: Array<{ fileName: string }>,
  fileName: string,
): boolean => files.some((file) => file.fileName === fileName);

export const validateKnowledgeBaseUpload = (
  file: KnowledgeBaseUploadFileLike,
  campaignId?: string,
): KnowledgeBaseUploadValidationError | null => {
  if (!campaignId) return 'campaignRequired';

  const hasPdfExtension = file.name.toLowerCase().endsWith('.pdf');
  if (!hasPdfExtension || (file.type && file.type !== KNOWLEDGE_BASE_PDF_MIME_TYPE)) {
    return 'fileType';
  }

  if (file.size > KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES) return 'fileSize';

  return null;
};
